// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"_2JfKb","perkIcon":"_3VzgF","title":"_1olSS","select":"_1zhA2","joinBtn":"_1nb2P","checkboxWrap":"qv7s5","checkboxInput":"_2MF5L"};